"use client";

import { Button } from "@frontend/roz-uikit/studio";
import { MenuIcon } from "lucide-react";

import { cn } from "@/lib/cn";
import { useSdkConfig } from "@/provider";
import { SheetContentType } from "@/types";
import { useSheetStore } from "@/ui-state";

export const MenuTrigger = () => {
  const { open, setType } = useSheetStore();
  const { theme } = useSdkConfig();

  const handleClick = () => {
    setType(SheetContentType.menu);
    open();
  };

  return (
    <Button
      aria-label="Открыть меню"
      className={cn(
        theme === "dark"
          ? "sdkui:text-white sdkui:hover:text-white sdkui:focus-visible:text-white sdkui:active:text-white"
          : "sdkui:text-dark-80"
      )}
      data-testid="menu-button"
      iconOnly
      onClick={handleClick}
      size="lg"
      variant="ghostPrimary"
    >
      <MenuIcon />
    </Button>
  );
};
